module.exports = __webpack_public_path__ + "media/images/flags/4x3/mhl-554fb812ec1be31aa85a0019bb850077.svg";